export const calendarData = {
  bsMonths: [
    'बैशाख',
    'जेठ',
    'आषाढ',
    'श्रावण',
    'भदौ',
    'असोज',
    'कार्तिक',
    'मंसिर',
    'पौष',
    'माघ',
    'फाल्गुन',
    'चैत्र'
  ],
  bsDays: ['आईत', 'सोम', 'मंगल', 'बुध', 'बिही', 'शुक्र', 'शनि'],
  bsDaysFull: ['आइतवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'बिहिवार', 'शुक्रवार', 'शनिवार'],
  nepaliNumbers: ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'],
  bsMonthUpperDays: [
    [30, 31],
    [31, 32],
    [31, 32],
    [31, 32],
    [31, 32],
    [30, 31],
    [29, 30],
    [29, 30],
    [29, 30],
    [29, 30],
    [29, 30],
    [30, 31]
  ],
  extractedBsMonthData: [
    [
      0, 1, 1, 22, 1, 3, 1, 1, 1, 3, 1, 22, 1, 3, 1, 3, 1, 22, 1, 3, 1, 19, 1, 3, 1, 1, 3, 1, 2, 2,
      1, 3, 1
    ],
    [
      1, 2, 2, 2, 2, 2, 2, 1, 3, 1, 3, 1, 2, 2, 2, 3, 2, 2, 2, 1, 3, 1, 3, 1, 2, 2, 2, 2, 2, 2, 2,
      2, 2, 2, 2, 1, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 1, 2, 2, 2, 2, 2, 1, 1, 1, 2, 2,
      2, 2, 2, 1, 3, 1, 1, 2
    ],
    [
      0, 1, 2, 1, 3, 1, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 1, 3, 1, 2,
      2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 1, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 1, 3, 1, 1, 1, 1, 2,
      2, 2, 2, 2, 1, 3, 1, 1, 2
    ],
    [
      1, 2, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 2, 2,
      2, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 2, 2, 2, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 2, 2, 1, 3,
      1, 2, 2, 2, 1, 2
    ],
    [59, 1, 26, 1, 28, 1, 2, 1, 12],
    [
      0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 1, 3, 1, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
      1, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 5, 1, 1, 2,
      2, 1, 3, 1, 2, 1, 2
    ],
    [0, 12, 1, 3, 1, 3, 1, 5, 1, 11, 1, 3, 1, 3, 1, 18, 1, 3, 1, 3, 1, 18, 1, 3, 1, 3, 1, 27, 1, 2],
    [
      1, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 2, 3, 1, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2,
      2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 15, 2, 4
    ],
    [
      0, 1, 2, 2, 2, 2, 1, 3, 1, 3, 1, 3, 1, 2, 2, 2, 3, 2, 2, 2, 1, 3, 1, 3, 1, 3, 1, 2, 2, 2, 2,
      2, 2, 2, 1, 3, 1, 3, 1, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 1, 3, 1, 2, 2, 2, 15, 2, 4
    ],
    [
      1, 1, 3, 1, 3, 1, 14, 1, 3, 1, 1, 1, 3, 1, 14, 1, 3, 1, 3, 1, 3, 1, 18, 1, 3, 1, 3, 1, 3, 1,
      14, 1, 3, 15, 1, 2, 1, 1
    ],
    [
      0, 1, 1, 3, 1, 3, 1, 10, 1, 3, 1, 3, 1, 1, 1, 3, 1, 3, 1, 10, 1, 3, 1, 3, 1, 3, 1, 3, 1, 14,
      1, 3, 1, 3, 1, 3, 1, 3, 1, 10, 1, 20, 1, 1, 1
    ],
    [
      1, 2, 2, 1, 3, 1, 3, 1, 3, 1, 2, 2, 2, 2, 2, 3, 2, 2, 2, 2, 2, 1, 3, 1, 3, 1, 3, 1, 2, 2, 2,
      2, 2, 2, 2, 1, 3, 1, 3, 1, 3, 1, 3, 1, 2, 2, 2, 2, 2, 2, 2, 1, 3, 1, 3, 1, 20, 3
    ]
  ],
  minBsYear: 1970,
  maxBsYear: 2100,
  minAdDateEqBsDate: {
    ad: {
      year: 1913,
      month: 3,
      date: 13
    },
    bs: {
      year: 1970,
      month: 1,
      date: 1
    }
  }
};

//import calendarData from './calendarData';

// const toDevanagariDigits = (number: any) => {
//     return String(number).split('').map((ed) => calendarData.nepaliNumbers[Number(ed)]).join('');
// }

const getTotalDaysNumFromMinBsYear = (bsYear: any, bsMonth: any, bsDate: any) => {
  if (bsYear < calendarData.minBsYear || bsYear > calendarData.maxBsYear) {
    return null;
  }

  let daysNumFromMinBsYear = 0;
  const diffYears = bsYear - calendarData.minBsYear;
  for (let month = 1; month <= 12; month++) {
    if (month < bsMonth) {
      daysNumFromMinBsYear += getMonthDaysNumFormMinBsYear(month, diffYears + 1);
    } else {
      daysNumFromMinBsYear += getMonthDaysNumFormMinBsYear(month, diffYears);
    }
  }

  if (bsYear > 2085 && bsYear < 2088) {
    daysNumFromMinBsYear += bsDate - 2;
  } else if (bsYear === 2085 && bsMonth > 5) {
    daysNumFromMinBsYear += bsDate - 2;
  } else if (bsYear > 2088) {
    daysNumFromMinBsYear += bsDate - 4;
  } else if (bsYear === 2088 && bsMonth > 5) {
    daysNumFromMinBsYear += bsDate - 4;
  } else {
    daysNumFromMinBsYear += bsDate;
  }

  return daysNumFromMinBsYear;
};

const getMonthDaysNumFormMinBsYear = (bsMonth: any, yearDiff: any) => {
  let yearCount = 0;
  let monthDaysFromMinBsYear = 0;
  if (yearDiff === 0) return 0;

  const bsMonthData = calendarData.extractedBsMonthData[bsMonth - 1];
  for (let i = 0; i < bsMonthData.length; i++) {
    if (bsMonthData[i] === 0) {
      continue;
    }
    const bsMonthUpperDaysIndex = i % 2;
    if (yearDiff > yearCount + bsMonthData[i]) {
      yearCount += bsMonthData[i];
      monthDaysFromMinBsYear +=
        calendarData.bsMonthUpperDays[bsMonth - 1][bsMonthUpperDaysIndex] * bsMonthData[i];
    } else {
      monthDaysFromMinBsYear +=
        calendarData.bsMonthUpperDays[bsMonth - 1][bsMonthUpperDaysIndex] * (yearDiff - yearCount);
      yearCount = yearDiff - yearCount;
      break;
    }
  }

  return monthDaysFromMinBsYear;
};

const getBsMonthDays = (bsYear: any, bsMonth: any) => {
  let yearCount = 0;
  const totalYears = bsYear + 1 - calendarData.minBsYear;
  const bsMonthData = calendarData.extractedBsMonthData[bsMonth - 1];
  for (let i = 0; i < bsMonthData.length; i++) {
    if (bsMonthData[i] === 0) {
      continue;
    }

    const bsMonthUpperDaysIndex = i % 2;
    yearCount += bsMonthData[i];
    if (totalYears <= yearCount) {
      if ((bsYear === 2085 && bsMonth === 5) || (bsYear === 2088 && bsMonth === 5)) {
        return +calendarData.bsMonthUpperDays[bsMonth - 1][bsMonthUpperDaysIndex] - 2;
      } else {
        return +calendarData.bsMonthUpperDays[bsMonth - 1][bsMonthUpperDaysIndex];
      }
    }
  }

  return null;
};

export const convertADtoBS = (adYear: any, adMonth: any, adDate: any) => {
  let bsYear = adYear + 57;
  let bsMonth = (adMonth + 9) % 12;
  bsMonth = bsMonth === 0 ? 12 : bsMonth;
  let bsDate = 1;

  if (adMonth < 4) {
    bsYear -= 1;
  }

  const bsMonthFirstAdDate = convertBStoAD(bsYear, bsMonth, 1);
  if (adDate >= 1 && adDate < bsMonthFirstAdDate.getDate()) {
    if (adMonth === 4) {
      const bsYearFirstAdDate = convertBStoAD(bsYear, 1, 1);
      if (adDate < bsYearFirstAdDate.getDate()) {
        bsYear -= 1;
      }
    }
    bsMonth = bsMonth !== 1 ? bsMonth - 1 : 12;
    const bsMonthDays: any = getBsMonthDays(bsYear, bsMonth);
    bsDate = bsMonthDays - (bsMonthFirstAdDate.getDate() - adDate) + 1;
  } else {
    bsDate = adDate - bsMonthFirstAdDate.getDate() + 1;
  }

  return { bsYear, bsMonth, bsDate };
};

export const convertBStoAD = (bsYear: any, bsMonth: any, bsDate: any) => {
  const daysNumFromMinBsYear: any = getTotalDaysNumFromMinBsYear(bsYear, bsMonth, bsDate);
  const adDate = new Date(
    calendarData.minAdDateEqBsDate.ad.year,
    calendarData.minAdDateEqBsDate.ad.month,
    calendarData.minAdDateEqBsDate.ad.date - 1
  );
  adDate.setDate(adDate.getDate() + daysNumFromMinBsYear);
  return adDate;
};
